import { jsxs as Y, Fragment as le, jsx as c } from "react/jsx-runtime";
import { c as g } from "./index-65016bfa.mjs";
import { createContext as ie, useContext as U, useMemo as G, forwardRef as me, useRef as q, useState as O, useCallback as L, useEffect as X } from "react";
import { useTheme as de, ThemeName as pe } from "@fcamna/shared-component-foundations";
import { u as ge } from "./useQuantum-50e8fd44.mjs";
import { a as x } from "./isClient-ec947a14.mjs";
import { b as E, a as Te } from "./useSlots-a1aa6a84.mjs";
import { u as fe } from "./useWindowSize-88e90e04.mjs";
import { Image as he } from "./image.js";
import V, { css as $ } from "styled-components";
import { AspectRatio as _e } from "./aspectRatio.js";
import { IconButton as He } from "./iconButton.js";
import { MediaDisclosureButton as Be } from "./mediaDisclosureButton.js";
import { S as ye } from "./screenReaderOnly-fd82ed96.mjs";
import { c as Pe } from "./combineRefs-90f27925.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
const Q = ie({ mediaRef: null }), Z = {
  Play: (e) => /* @__PURE__ */ c("button", { ...e }),
  Pause: (e) => /* @__PURE__ */ c("button", { ...e })
};
function R({
  onClick: e,
  className: s,
  playButtonAccessibilityOptions: n,
  accessibilityOptions: m,
  ...I
}) {
  var l, H;
  const { mediaRef: o } = U(Q), { themeName: N } = de(), T = E(I.children, Z, E.PickType.LAST), a = G(
    () => {
      var B, y;
      return o != null && o.isPlaying ? (B = T.Play) == null ? void 0 : B.props : (y = T.Pause) == null ? void 0 : y.props;
    },
    [o == null ? void 0 : o.isPlaying, T]
  );
  function f(B) {
    var y;
    o && (o != null && o.isPlaying ? o == null || o.pause() : o == null || o.play(), e == null || e(B, o == null ? void 0 : o.isPlaying), (y = a == null ? void 0 : a.onClick) == null || y.call(a, B, o == null ? void 0 : o.isPlaying));
  }
  return /* @__PURE__ */ Y(le, { children: [
    /* @__PURE__ */ c(
      Me,
      {
        color: N === pe.FORD_CREDIT ? "oncolor" : "default",
        accessibilityOptions: o != null && o.isPlaying ? { ariaLabel: "Pause", ...(n == null ? void 0 : n.pauseButton) || m } : { ariaLabel: "Play", ...(n == null ? void 0 : n.playButton) || m },
        ...I,
        ...a,
        onClick: f,
        iconName: o != null && o.isPlaying ? "pause" : "playFilled",
        className: g(["Card__Media-play-btn", a == null ? void 0 : a.className, s])
      }
    ),
    /* @__PURE__ */ c(ye, { children: (a == null ? void 0 : a.children) || (o != null && o.isPlaying ? ((l = n == null ? void 0 : n.playing) == null ? void 0 : l.ariaLabel) || "Playing" : ((H = n == null ? void 0 : n.paused) == null ? void 0 : H.ariaLabel) || "Paused") })
  ] });
}
R.Props = Z;
const we = V(_e)`
  &.Hero {
    ${({
  theme: {
    components: { hero: e }
  },
  $styles: s
}) => $(e.Hero, s)};
  }
`, Ve = V.div`
  &.Hero-overlay {
    ${({
  theme: {
    components: { hero: e }
  }
}) => e.MediaOverlay}
  }
`, Ie = V(R)`
  &.Hero__play-btn {
    ${({
  theme: {
    components: { hero: e }
  }
}) => $(e.FloatingPlaybackButton)};
  }
`, $e = V.div`
  &.Hero__contents {
    ${({
  theme: {
    components: { hero: e },
    componentStyles: s
  }
}) => $(e.Contents, s)};
  }
`, Ce = V.h1`
  &.Hero__contents-title {
    ${({
  theme: {
    components: { hero: e }
  }
}) => $(e.Title)};
  }
`, ve = V.p`
  &.Hero__contents-body {
    ${({
  theme: {
    components: { hero: e }
  }
}) => $(e.Body)};
  }
`, Ne = V.div`
  &.Hero__contents-button-group {
    ${({
  theme: {
    components: { hero: e }
  }
}) => $(e.ButtonGroup)};
  }
`, be = V(Be)`
  &.Hero__disclosures {
    ${({
  theme: {
    components: { hero: e }
  }
}) => $(e.DisclosureButton)};
  }
`, Me = V(He)`
  &.Card__Media-play-btn {
    ${({
  theme: {
    components: { hero: e }
  }
}) => $(e.PlaybackButton)};
  }
`, Fe = ({ headingLevel: e = "h1", as: s = e, renderAs: n = s, className: m, ...I }) => /* @__PURE__ */ c(
  Ce,
  {
    className: g(["Hero__contents-title", m]),
    as: n,
    ...I
  }
), De = ({ className: e, ...s }) => /* @__PURE__ */ c(
  ve,
  {
    className: g(["Hero__contents-body", e]),
    ...s
  }
);
function Le({ className: e, children: s, ...n }) {
  return /* @__PURE__ */ c(
    Ne,
    {
      ...n,
      className: g(["Hero__contents-button-group", e]),
      children: s
    }
  );
}
function _({ className: e, children: s, ...n }) {
  return /* @__PURE__ */ c(
    $e,
    {
      ...n,
      className: g(["Hero__contents", e]),
      children: s
    }
  );
}
_.Title = Fe;
_.Body = De;
_.ButtonGroup = Le;
const A = ({
  disclosureLinks: e = {},
  containerPosition: s,
  ...n
}) => /* @__PURE__ */ c(
  be,
  {
    ...e,
    ...n
  }
);
var p = /* @__PURE__ */ ((e) => (e.TOP_LEFT = "top-left", e.TOP_RIGHT = "top-right", e.TOP = "top", e.LEFT = "left", e.CENTER = "center", e.RIGHT = "right", e.BOTTOM = "bottom", e.BOTTOM_LEFT = "bottom-left", e.BOTTOM_RIGHT = "bottom-right", e))(p || {});
const ee = me(function({
  videoProps: s = {},
  className: n,
  loopAmount: m,
  playsInline: I = !0,
  autoPlay: o = !0,
  muted: N = !0,
  loop: T = !0,
  pauseTime: a = -1,
  onPlay: f,
  onPause: l,
  onEnded: H,
  ...B
}, y) {
  const S = q(m ?? 0), u = q(null), { setMediaRef: P } = U(Q), [b, k] = O(!1), j = L(
    (i) => {
      k(!0), f == null || f(i);
    },
    [f]
  ), z = L(
    (i) => {
      k(!1), l == null || l(i);
    },
    [l]
  ), W = L(
    (i) => {
      H == null || H(i), u.current && m && (o && S.current > 1 ? (S.current -= 1, u.current.currentTime = 0, u.current.play()) : (a >= 0 && (u.current.currentTime = a), u.current.pause()));
    },
    [o, m, H, a]
  ), M = L(() => {
    var i;
    (i = u.current) == null || i.play();
  }, []), t = L(() => {
    var i;
    (i = u.current) == null || i.pause();
  }, []), C = L(() => {
    b ? t() : M();
  }, [b, t, M]);
  return X(() => {
    P == null || P({
      element: u.current,
      play: M,
      pause: t,
      toggle: C,
      isPlaying: b
    });
  }, [b, t, M, P, C]), /* @__PURE__ */ c(
    "video",
    {
      ...s,
      ...B,
      className: g(["Card__Media-video Video", n]),
      loop: typeof m > "u" && o ? T : !1,
      playsInline: I,
      autoPlay: o,
      muted: N,
      onPlay: j,
      onPause: z,
      onEnded: W,
      ref: Pe(y, u)
    }
  );
}), oe = (e) => /* @__PURE__ */ c(Ve, { ...e }), Ge = (e) => /* @__PURE__ */ c("div", { ...e }), Ee = {
  [p.TOP_LEFT]: "start-start",
  [p.TOP_RIGHT]: "start-end",
  [p.TOP]: "start-center",
  [p.LEFT]: "center-start",
  [p.CENTER]: "center-center",
  [p.RIGHT]: "center-end",
  [p.BOTTOM]: "end-center",
  [p.BOTTOM_LEFT]: "end-start",
  [p.BOTTOM_RIGHT]: "end-end"
}, r = ({
  contentAlignment: e = p.LEFT,
  coverNavBar: s,
  isLoggedIn: n,
  showPlaybackButton: m,
  showOverlay: I = !0,
  hideOverlay: o = !I,
  hideOverlayOnPlay: N,
  hideContentsOnPlay: T,
  hideDisclosureLinksOnPlay: a,
  onClick: f,
  disclosureLinks: l,
  className: H,
  children: B,
  ...y
}) => {
  var J, K;
  const S = ge({ label: "Hero" }), u = q(null), [P, b] = O(null), [k, j] = O({
    marginTop: 0,
    marginInline: 0
  }), [z, W] = O(x && window.document.body.offsetHeight), { width: M } = fe(), t = E(
    B,
    {
      VideoContainer: r.VideoContainer,
      Image: [r.Image, "img"],
      Video: [r.Video, r.VideoElement, "video"],
      Contents: [r.HeaderContainer, r.Contents],
      Overlay: r.Overlay,
      PlaybackButton: r.PlaybackButton,
      DisclosureButton: r.DisclosureButton
    },
    E.PickType.LAST
  ), C = E(
    (K = (J = t.VideoContainer) == null ? void 0 : J.props) == null ? void 0 : K.children,
    {
      Image: [r.Image, "img"],
      Video: [r.Video, "video"],
      Overlay: r.Overlay
    },
    E.PickType.LAST
  ), { Image: i, Video: te, Overlay: v } = G(
    () => ({
      Image: t.Image || C.Image,
      Video: t.Video || C.Video,
      Overlay: t.Overlay || C.Overlay
    }),
    [t, C]
  );
  Te(x && window.document.body, () => x && W(window.document.body.offsetHeight)), X(() => {
    if (!s || !x || !(u != null && u.current))
      return;
    const F = u.current.getBoundingClientRect(), h = (window.pageYOffset || window.scrollY) + F.top, d = F.left;
    j((D) => ({
      width: "auto",
      marginTop: parseInt(`${D.marginTop || 0}`) - h,
      marginLeft: parseInt(`${D.marginLeft || 0}`) - d,
      marginRight: parseInt(`${D.marginRight || 0}`) - d
    }));
  }, [M, n, z, s]);
  const [re, ne] = Ee[e].split("-"), w = P == null ? void 0 : P.isPlaying, se = G(() => !o && !(N && w) ? /* @__PURE__ */ c(
    oe,
    {
      ...v == null ? void 0 : v.props,
      className: g(["Hero-overlay", { "Hero-overlay--playing": w }, v == null ? void 0 : v.props.className])
    }
  ) : null, [N, w, v, o]), ae = G(() => {
    var h, d, D;
    return (!!t.Contents || !!t.rest) && !(T && w) ? /* @__PURE__ */ Y(
      _,
      {
        ...(h = t.Contents) == null ? void 0 : h.props,
        className: g([
          `Hero__contents--${e}`,
          { "Hero__contents--cover-navbar": s },
          (d = t.Contents) == null ? void 0 : d.props.className
        ]),
        children: [
          t.rest,
          (D = t.Contents) == null ? void 0 : D.props.children
        ]
      }
    ) : null;
  }, [e, s, T, w, t.Contents, t.rest]), ce = G(() => {
    var h, d;
    return m || !!t.PlaybackButton || T && w ? /* @__PURE__ */ c(
      Ie,
      {
        onClick: f,
        ...(h = t.PlaybackButton) == null ? void 0 : h.props,
        className: g(["Hero__play-btn", (d = t.PlaybackButton) == null ? void 0 : d.props.className])
      }
    ) : null;
  }, [T, w, f, m, t.PlaybackButton]), ue = G(() => {
    var h, d;
    return (l || !!t.DisclosureButton) && !(a && w) ? /* @__PURE__ */ c(
      A,
      {
        ...l,
        alignment: "bottom-right",
        ...(h = t.DisclosureButton) == null ? void 0 : h.props,
        className: g(["Hero__disclosures", l == null ? void 0 : l.className, (d = t.DisclosureButton) == null ? void 0 : d.props.className])
      }
    ) : null;
  }, [l, a, w, t.DisclosureButton]);
  return /* @__PURE__ */ c(Q.Provider, { value: { mediaRef: P, setMediaRef: b }, children: /* @__PURE__ */ Y(
    we,
    {
      ref: u,
      className: g(["Hero", `Hero--${e}`, H]),
      $styles: {
        alignItems: re,
        justifyContent: ne,
        ...s ? k : void 0
      },
      onClick: f,
      objectFit: "cover",
      maxHeight: "100%",
      ...S,
      ...y,
      children: [
        te || i,
        se,
        ae,
        ce,
        ue
      ]
    }
  ) });
};
r.Overlay = oe;
r.Video = ee;
r.Image = he;
r.Contents = _;
r.Title = _.Title;
r.Body = _.Body;
r.ButtonGroup = _.ButtonGroup;
r.PlaybackButton = R;
r.DisclosureButton = A;
r.HeaderContainer = _;
r.VideoContainer = Ge;
r.VideoElement = ee;
r.CTAButtonContainer = _.ButtonGroup;
const co = r;
export {
  r as Hero,
  p as HeroContentAlignment,
  co as HeroVideoV1
};
